export default __webpack_public_path__ + "static/media/example-art-2.239cbba5.webp";